/** Converts an array of objects to a CSV string and triggers a browser download. */
export function exportCsv(
  rows: Record<string, string | number | null | undefined>[],
  columns: { header: string; key: string }[],
  filename: string
) {
  const escape = (val: string | number | null | undefined): string => {
    if (val == null) return "";
    const str = String(val);
    // Wrap in quotes if contains comma, quote, or newline
    return str.includes(",") || str.includes('"') || str.includes("\n")
      ? `"${str.replace(/"/g, '""')}"`
      : str;
  };

  const header = columns.map((c) => escape(c.header)).join(",");
  const body = rows
    .map((row) => columns.map((c) => escape(row[c.key])).join(","))
    .join("\n");

  const csv = `${header}\n${body}`;
  const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  link.click();
  URL.revokeObjectURL(url);
}
